<template>
  <div v-if="isError" class="poster" :style=" isAI ? '' : 'background: linear-gradient(90deg,#557aff 0%,#4642ff 6.41%,#ff5572 102.62%);'">
    <div class="water-mark" v-watermark="watermarkConfig" @click="test"></div>
    <div
      class="bodydiv"
      :style="
        `padding-bottom: 27px;
        ${isAI
          ? 'background-color: RGB(64, 64, 74);'
          : 'background: linear-gradient(270.23deg, #093E73 0.15%, #1A65A9 99.76%)'}`
      "
    >
      <div v-if="!isAI" class="ccic-top">
        <img :src="header" alt="">
      </div>
      <div class="top-desc">
        <div class="desc_title">
          <span
            :style="
            `
            ${isAI
                ? 'background-color: RGB(64, 64, 74);'
                : 'background-color: RGB(10,63,116);'
            }`"
              
          >
            产品信息
          </span>
        </div>
        <div class="desc_result" style="margin-top:10px;font-size: 22px;height:28px;">
          <!-- <el-image 
                    src="https://oss.turingsenseai.com/1623909016721708515.png" 
                    :preview-src-list="srcList">
                </el-image> -->
          <img
            v-if="!ifFake"
            style="left: 40%;top:-5px;"
            src="https://oss.turingsenseai.com/1623909016721708515.png"
          />
          <img
            v-else
            :style="`${noAppraisal ? 'left: 40%;width: 30px;left': 'left: 32%;width: 30px;'}`"
            src="https://oss.turingsenseai.com/1623908979338852921.png"
          />
          <p style="font-size: 22px;line-height: 32px;">{{ noAppraisal ? (ifFake ? "不符合正品工艺" : "符合正品工艺" ): "无法鉴别"}}</p>
        </div>
        <div class="desc_container">
          <div class="desc_info">
            <div class="info_item">
              <div>
                <span>商品品牌:</span>
                <p>{{ brandName }}</p>
              </div>
              <div>
                <span>商品品类:</span>
                <p>{{ kindName }}</p>
              </div>
              <div>
                <span>鉴别编号:</span>
                <p>{{ OAID }}</p>
              </div>
            </div>
            <div class="info_img">
              <!-- <el-image 
                        src="https://oss.turingsenseai.com/baogo1626335863503802006.png" 
                        :preview-src-list="detailImgList">
                    </el-image> -->
              <img :src="exteriorUrl" />
              <div class="img_mark"></div>
            </div>
          </div>
          <div class="desc">
            <span class="desc_label">整体评价:</span>
            <div v-show="showMore" class="label_container">
              <p>
                {{
                  `${descList[0]}${
                    descList[1] ? descList[1].slice(0, 2) : ""
                  }...`
                }}
              </p>
            </div>
            <div v-show="!showMore" class="label_container">
              <!-- 根据具体行数判断 -->
              <p v-for="(item, index) in descList" :key="index">
                {{ item }}
              </p>
            </div>
          </div>
          <div class="more">
            <p v-show="showMore" @click="descShowMore(1)">查看更多</p>
            <p v-show="!showMore" @click="descShowMore(0)">收起</p>
          </div>
        </div>
      </div>
      <div v-if="noAppraisal" class="bottom-detail">
        <div class="detail_title">
          <h3>细节检测</h3>
        </div>
        <div class="detail_container">
          <van-tabs class="tabs">
            <van-tab
              title-style="position: relative; z-index:6;"
              v-for="(item, index) in SARecordList"
              :key="index"
              :title="item.pointName"
            >
              <div class="point_content">
                <div class="precent">
                  <div>
                    <span
                      class="position_text"
                      :style="
                        `left: ${parseInt(
                          (item.grade * 100).toFixed()
                        )}%; transform: scale(0.9) translateX(-${
                          parseInt((item.grade * 100).toFixed()) >= 50 ? 89 : 10
                        }%);`
                      "
                      >符合度{{ parseInt((item.grade * 100).toFixed()) }}%</span
                    >
                    <span
                      class="position"
                      :style="
                        `font-size: 1pt;transform: translateY(-9px);left: ${parseInt((item.grade * 100).toFixed())}%`
                      "
                    ></span>
                  </div>
                  <div class="linear"></div>
                  <div class="precent_tip" style="font-size: 11px;">
                    <span>0% 仿品</span><span>100% 正品</span>
                  </div>
                </div>
                <div
                  class="ponit_pic"
                  :style="
                    ifFake && item.fakePoints.length > 0
                      ? 'justify-content: space-between;'
                      : 'justify-content: center;'
                  "
                >
                  <div
                    :class="
                      ifFake && item.fakePoints.length > 0 ? 'picT' : 'trueP'
                    "
                  >
                    <img
                      :src="item.image"
                      :class="
                        ifFake && item.fakePoints.length > 0 ? '' : 'truePic'
                      "
                      alt=""
                    />
                    <div
                      :class="
                        ifFake && item.fakePoints.length > 0
                          ? 'pic_markF'
                          : 'pic_markT'
                      "
                    >
                      <img
                        v-if="
                          ifFake && item.fakePoints.length > 0 ? false : true
                        "
                        :class="
                          ifFake && item.fakePoints.length > 0
                            ? 'trueArea'
                            : 'trueArea'
                        "
                        ref="detectionBox"
                        src="https://oss.turingsenseai.com/15952947223287.png"
                        :style="
                          `left:${item.detectionBox.x *
                            ((isPcFlag ? 300 * 1.5 : screenWidth * 0.8 * 0.5) /
                              item.originalBox.width)}px;
                          top:${item.detectionBox.y *
                            ((isPcFlag ? 270 * 0.8: screenWidth * 0.83 * 0.6) /
                              item.originalBox.height)}px;
                          width:${item.detectionBox.width *
                            ((isPcFlag ? 300 * 1.1: screenWidth * 0.9 * 0.7) /
                              item.originalBox.width)}px;
                          height:${item.detectionBox.height *
                            ((isPcFlag ? 300 * 1.1 : screenWidth * 0.9 * 0.6) /
                              item.originalBox.height)}px;object-fit: fill;`
                        "
                      />

                      <img
                        v-else
                        :class="
                          ifFake && item.fakePoints.length > 0
                            ? 'trueArea'
                            : 'trueArea'
                        "
                        class="ssss"
                        ref="detectionBox"
                        src="https://oss.turingsenseai.com/15952947223287.png"
                        :style="
                          `left:${item.detectionBox.x *
                            ((isPcFlag ? 260 * 1.1 : screenWidth * 0.7 * 0.5) /
                              item.originalBox.width)}px;
                          top:${item.detectionBox.y *
                            ((isPcFlag ? 230 : screenWidth * 0.68 * 0.6) /
                              item.originalBox.height)}px;
                          width:${item.detectionBox.width *
                            ((isPcFlag ? 260 * 1 : screenWidth * 0.83 * 0.5) /
                              item.originalBox.width)}px;
                          height:${item.detectionBox.height *
                            ((isPcFlag ? 260 * 1 : screenWidth * 0.75 * 0.5) /
                              item.originalBox.height)}px;
                          object-fit: fill;`
                        "
                      />
                    </div>
                    
                    <p>原图</p>
                  </div>
                  <div v-if="ifFake && item.fakePoints.length > 0" class="picF">
                    <img :src="item.croppedImageURL" alt="" />
                    <!-- <div
                      v-for="(item, index) in item.fakePoints"
                      :key="index"
                      class="fake_mark"
                      :style="`left:${item.x / 1.5}px;top:${item.y / 1.6}px;`"
                    ></div> -->
                    <!-- 红点热区修改比例即可 -->
                    <div
                      :class="
                        ifFake && item.fakePoints.length
                          ? 'pic_markF'
                          : 'pic_markT'
                      "
                    ></div>
                    <p>偏假区域</p>
                  </div>
                </div>
                <div class="point_dsc">
                  <p>
                    {{ item.description }}
                  </p>
                </div>
              </div>
            </van-tab>
          </van-tabs>
        </div>
      </div>
      <div v-else class="bottom-detail">
        <div class="no_title" style="line-height: 25px;margin: 10px 0;font-size: 18px;">无法鉴别的常见原因</div>
        <div class="reason" style="font-size: 12px;line-height: 22px;margin-bottom: 12px;">
          <p>1. 图片清晰度较低;</p>
          <p>2. 拍摄鉴定点位置不正确;</p>
          <p>3. 鉴定点变形等</p>
        </div>
      </div>
    </div>
    <div v-if="!isAI" class="ccic-bottom">
      <img src="https://oss.turingsenseai.com/1624005265917545236.png" alt="">
    </div>
    <div
      class="shaer_mark"
      v-if="!ifFake"
      style="background-color: #F8F8FB;height:30px;"
    ></div>
    <van-popup
      :class="clientWidth > 500 ? 'boswer_poster' : 'poster'"
      v-model="show"
      position="bottom"
      :lazy-render="false"
      closeable
      @opened=" savePic"
      :style="{
        height: !isPcFlag ? (isAI ? '82vh' : '92vh') : '800px',
        width: clientWidth > 500 ? '575px' : '',
      }"
    >
      <div class="pc-mark" v-show="pcMark"><van-loading /></div>
      <div class="poster_title">
        <span>保存到相册</span>
      </div>
      <div
        class="poster_container"
        :style="
          !isPcFlag
            ? isAI
              ? 'width:275px;height: 68vh;'
              : 'width:300px;height: 78vh;'
            : 'height: 681px;align-items: unset;'
        "
      >
        <!-- isPosterPic 是否显示图片false为html，true为图片 -->
        <div
          ref="image"
          v-if="isPosterPic"
          class="back_img"
          :style="
            `
    width: 300px;${
      !isPcFlag ? (isAI ? 'height: 400px;' : 'height: 620px;') : 'width: 375px;height:600px;'
    }`
          "
        >
          <img
            class="back_IMG"
            :src="isAI ? ai :ccic"
            alt=""
            :style="
              `width:300px;${
                !isPcFlag
                  ? isAI
                    ? 'height: 400px;'
                    : 'height: 620px;'
                  : 'width: 350px;height: 600px;'
              }`
            "
          />
          <!-- :style="isPc ? 'height: 57px;width: 250px;line-height: 57px;':''" -->
          <!-- <div class="back_IMG"
          :style="
            `width:275px;background-image:url(${backBase64}); background-size: 100% 100%; ${
              !isPcFlag ? (isAI? 'height: 400px;': 'height: 500px;') : 'width: 250px;height: 450px;'
            }`
          "></div> -->
          <div
            class="isAI_mark"
            v-if="!isAI"
            :style="isPcFlag ? 'height: 108px;width: 350px;' : 'height:114px;'"
          ></div>
          <div
            v-else
            :style="isPcFlag ? 'height: 15px;width: 250px;' : ''"
          ></div>
          <span
            class="back_title"
            :style="
              !isPcFlag
                ? isAI
                  ? 'line-height: 82px;'
                  : 'line-height: 71px;'
                : 'height: 75px;width: 350px;line-height: 75px;margin-bottom:0;'
            "
            >符合正品工艺</span
          >
          <div
            class="poster_info"
            :style="
              !isPcFlag ? (isAI ? 'height:100px;margin: 0 11px;margin-bottom:10px;' : 'height:100px;margin: 0 11px;') : isAI ? 'width: 248px;margin-bottom: 53px;' : 'width: 345px;margin-bottom: 40px'
            "
          >
            <div class="poster_item" :style="`${isPcFlag ? 'height: 77px;' : ''}`">
              <div style="margin-bottom: 14px;">
                <span style="margin-right: 13px;">商品品牌</span>
                <p>{{ brandName }}</p>
              </div>
              <div style="margin-bottom: 14px;">
                <span style="margin-right: 13px;">商品品类</span>
                <p>{{ kindName }}</p>
              </div>
              <div style="margin-bottom: 14px;">
                <span style="margin-right: 13px;">鉴别编号</span>
                <p>{{ OAID }}</p>
              </div>
              <div style="margin-bottom: 14px;">
                <span style="margin-right: 13px;">鉴别日期</span>
                <p>
                  {{
                    `${appraisalTime[0]}年${appraisalTime[1]}月${appraisalTime[2]}日`
                  }}
                </p>
              </div>
            </div>
            <div
              class="poster_img"
              :style="
                `width:75px;`
              "
              alt=""
            >
              <img :src="exteriorUrl" />
            </div>
          </div>
          <div
            class="poster_desc"
            :style="
              isPcFlag
                ? 'width: 335px;margin-left: 30px;'
                : 'margin-left: 24px;margin-top:36px;'
            "
          >
            <span class="desc_title" style="margin-bottom: 11px;font-size: 17px;font-weight: 500;">综合评分: {{ precent.toFixed() }}</span>
            <p v-for="(item,index) in descriptionList" :key="index" :style="isPcFlag ? 
            'height:17px;font-size: 2px;line-height: 19px;overflow: hidden;color: #2A2A30;text-align:justify;': 
            'height:18px;font-size: 12px;line-height: 19px;overflow: hidden;color: #2A2A30;text-align:justify;'">
              {{item}}
            </p>
          </div>
          <div v-if="!isAI" class="bottom-icon" :style=" isPcFlag ? 'height:130px;' : 'height:125px;'"></div>
          <div v-else class="bottom-icon" :style="isPcFlag ? 'height:58px;' : 'height:36px;'"></div>
          <div
            class="qrcode"
            :style="
              `background-image:url(${this.imgData});${
                isPcFlag ? (isAI ? 'transform: translateX(-20px);' : 'margin: 0px 0 0 63%;') : ''
              }`
            "
          >
            <div v-show="false" class="qrcode" ref="qrCodeUrl"></div>
            <img :src="imgData" />
          </div>
        </div>
        <img
          v-else
          class="downImg"
          :style="
            `background-image:url(${this.backBase64}); ${
              !isPcFlag
                ? isAI
                  ? 'width: 275px;height: 400px;background-size: 100% 400px'
                  : 'width: 300px;height: 620px;background-size: 100% 500px'
                : ''
            }`
          "
          :src="posterPic"
          alt=""
        />
      </div>
      <van-button
        v-if="isPcFlag"
        class="save"
        type="primary"
        size="large"
        @click="fileDownload(posterPic)"
        >保存图片</van-button
      >
      <van-button v-else class="save" type="primary" size="large"
        >长按图片保存</van-button
      >
    </van-popup>
    
    <div v-if="!ifFake" class="share" 
    :style="`height: 89px;${isPcFlag ? 'width: 100vw;': ''}`" 
    @click="show = !show">
      <span style="margin-top: 4px;
    height: 40px;
    line-height: 40px;">下载鉴别结论</span>
      <div></div>
    </div>
    <div v-if="isPcFlag ? false : true " style="width:100vw;height:100%;position: absolute;top:0;z-index:9999;background-color:#4C4C4C;opacity: 0.8;display: flex;justify-content: center;align-items: center;" :style="saveLoading ? '' : 'display:none;'">
      <van-loading size="60px" />
    </div>
  </div>
</template>

<script>
import "@/common/js/watermark.js";
import bg0 from '@/assets/images/ccic-picture/ccic.png'
import bg2 from '@/assets/images/appraisal/header.png'
import bg1 from '@/assets/images/appraisal/ai.png'
import html2canvas from "html2canvas";
import QRCode from "qrcodejs2";
import { HOST_ADDRESS } from "../../common/constant";
import {
  fetchCCICReportDetail,
} from "@/common/api/appraisal.js";
export default {
  mounted() {
    this.getData();
  },
  data() {
    return {
      eleLoading: false,
      saveLoading: false,
      pcMark: false,
      ccic: bg0,
      ai:bg1,
      header: bg2,
      isError: false,
      clientWidth: "",
      imgData: "",
      // 组件
      watermarkConfig: {
        // AIGJXGAJ
        //水印
        text: "图灵鉴定(包小鉴)",
        font: "18px 微软雅黑",
        textColor: "rgba(255,255,255,0.2)",
        width: 170, //水印文字的水平间距
        height: 60, //水印文字的高度间距（低于文字高度会被替代）
        extRotate: -30, //-90到0， 负数值，不包含-90
      },
      showMore: true,
      descList: [],

      // 获取数据
      isAI: false,
      ifFake: false, // 是否符合
      noAppraisal: false,
      kindName: "",
      brandName: "",
      seriesName: "",
      description: "",
      descriptionList:[],
      exteriorUrl: "", // 外观图片URL
      appraisalTime: [],
      SARecordList: [], // 详情鉴定列表
      precent: 0,
      OAID: "",
      fakePoints: [],
      exteriorUrlList: [],
      qrcode: "",
      // 弹出层
      show: false,
      backBase64: "",
      exteriorBase64: "",
      screenWidth: document.documentElement.clientWidth, //屏幕宽度
      screenHeight: document.documentElement.clientHeight, //屏幕宽度
      DBwidth: "",
      // 海报图片
      posterPic: "",
      isPosterPic: true,
      isPcFlag: "",
      Flag: true,
      openError : false
    };
  },
  methods: {
    async getData() {
      this.isPcFlag = this.IsPc();
      this.clientWidth = window.clientWidth;
      // this.isAI = this.$route.params.ai == 0 ? true : false;
      // console.log(isAI);
      let OAIDARY = this.$route.params.appraisalno.split("-"); // 不符合 AIIOVGQT 符合 AIZ0A9L8 中检不符合 AI1RUMJ0 符合 AI7XSULH
      let OAID = "";
      if (OAIDARY.length > 1) {
        OAID = OAIDARY[0] + OAIDARY[1];
      } else {
        OAID = OAIDARY[0];
      }
      await fetchCCICReportDetail({ OAID }).then((res) => {
        this.isError = true;
        if (res.errorMsg == "Success") {
          this.ifFake = res.genuine == "1" ? false : true;
          this.noAppraisal = res.genuine == "3" ? false : true; // false 为无法鉴别
          this.kindName = res.kindName;
          this.brandName = res.brandName;
          this.seriesName = res.seriesName;
          this.description = res.description;
          this.descriptionList.push(res.description.slice(0,22))
          this.descriptionList.push(res.description.slice(21,44))
          let lastText = `${res.description.slice(43,55)}`
          this.descriptionList.push(lastText)
          this.exteriorUrl = `data:image/png;base64,${res.exteriorUrl}`;
          this.OAID = res.OAID;
          this.precent = res.grade * 100; //综合评分
          res.SARecordList.forEach((item, index) => {
            this.SARecordList.push(item);
          });
          
          this.appraisalTime = res.appraisalTime.split(" ")[0].split("-");
          this.descList = this.description.split("\n");
        } else {
          this.isError = false;
        }
      });
      // await getMainPic({
      //         OAID: res.OAID
      //     }).then(res => {
      //       console.log(res);
      //     })
      // 执行时间太长阻塞主图渲染，采用静态图片。
      // this.getBase64Image(
      //   this.isAI
      //     ? "https://oss.turingsenseai.com/1625645455506715526.png"
      //     : "https://oss.turingsenseai.com/1624003695658367057.png",
      //   (dataURL) => {
      //     this.backBase64 = dataURL;
      //   }
      // );
      // this.eleLoading = true
      // let Img = new Image()
      // Img.src = this.exteriorUrl + "?v=" + Math.random();
      // Img.setAttribute("crossOrigin", "Anonymous");
      // let that = this
      // Img.onload = function() {
      //   let canvas = document.createElement("canvas"),
      //     width = Img.width,
      //     height = Img.height;
      //   canvas.width = width;
      //   canvas.height = height;
      //   canvas.getContext("2d").drawImage(Img, 0, 0, width, height);
      //   that.exteriorBase64  = canvas.toDataURL("image/png");
      //   console.log(that.exteriorBase64);
      //   this.eleLoading = false
      // };
      
      this.creatQrCode();
    },
    descShowMore(flag) {
      flag ? (this.showMore = false) : (this.showMore = true);
    },
    getCodeHeight() {
      let { isPcFlag, screenHeight } = this;
      let height = !isPcFlag
        ? screenHeight < 760
          ? screenHeight < 730
            ? screenHeight < 700
              ? screenHeight < 670
                ? screenHeight < 645
                  ? "height:10.5vh;"
                  : "height:11vh;"
                : "height:12vh;"
              : "height:13vh;"
            : "height:13vh;"
          : "height:15vh;"
        : "height:13%;";
      return height;
    },
    savePic() {
      // 没啥用
      if ( this.openError ) {
        Toast.loading({
          message: '图片加载失败请刷新重试',
        });
      }
      
      if (this.Flag) {
        document.scrollingElement.scrollTop = 0;
        if (this.isPcFlag) {
        this.pcMark = true
      }
        this.saveLoading = true
        let that = this
        setTimeout(() => {
          html2canvas(this.$refs.image, {
            useCORS: true,
            // scale: 4,
            // scrollY: 0,
            // scrollX: 0,
          }).then((canvas) => {
            if (this.isPcFlag) {
              this.pcMark = false
            }
            this.posterPic = canvas.toDataURL("image/png");
            this.saveLoading = false
            this.Flag = false
            this.isPosterPic = false;
            that.posterPic = canvas.toDataURL("image/png");
            that.saveLoading = false
            that.Flag = false
            that.isPosterPic = false;
            // let imgData = canvas.toDataURL("image/png");
            // 保存方式
            // this.fileDownload(imgData);
          });
        }, 2000);
        setTimeout(() => {
          this.saveLoading = false
        }, 2200);
      }
    },
    // @opned执行savepic先生成整个海报再用海报渲染点击后下载
    // 直接保存到相册
    // 目前选用长按保存方案PC使用下载
    fileDownload(imgdata) {
      let aLink = document.createElement("a");
      aLink.style.display = "none";
      aLink.download = "图灵鉴定.png";
      // aLink.href = this.posterPic;
      aLink.href = URL.createObjectURL(this.dataURLtoBlob(imgdata));
      // 触发点击-然后移除
      document.body.appendChild(aLink);
      aLink.click();
      document.body.removeChild(aLink);
    },
    getBase64Image(url, callback) {
      this.eleLoading = true
      let Img = new Image(),
        dataURL = "";
        // Math.random()
      Img.src = url + "?v=" + Math.random();
      Img.setAttribute("crossOrigin", "Anonymous");
      try {
        Img.onload = function() {
        let canvas = document.createElement("canvas"),
          width = Img.width,
          height = Img.height;
        canvas.width = width;
        canvas.height = height;
        canvas.getContext("2d").drawImage(Img, 0, 0, width, height);
        let quality = 0.1
        dataURL = canvas.toDataURL("image/jpeg",quality);
        while (dataURL.length / 1024 > 150) {
                quality -= 0.01;
                dataURL = canvas.toDataURL("image/jpeg", quality);
            }
        this.eleLoading = false
        return callback ? callback(dataURL) : null;
      };
      } catch (error) {
        this.openError = true
      }
    },
    async creatQrCode() {
      this.qrcode = new QRCode(this.$refs.qrCodeUrl, {
        text: `${HOST_ADDRESS()}cicc-report/${
          this.$route.params.appraisalno
        }`, // 需要转换为二维码的内容
        // text: `${HOST_ADDRESS()}wallet`,
        width: 100,
        height: 100,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: 1,
      });
      // let base64Img = `${this.$refs.qrCodeUrl.childNodes[1].currentSrc}`
      // let res = await uploadImageFromBase64(base64Img)
      let qrCanvs = this.$refs.qrCodeUrl.childNodes[0];
      let qrcBase64 = qrCanvs.toDataURL("image/webp");
      this.imgData = `${qrcBase64}`;
    },
    async codeTobase64() {
      await this.creatQrCode();
      this.imgData = `${this.$refs.qrCodeUrl.childNodes[1].currentSrc}`;
    },
    IsPc() {
      let userAgentInfo = navigator.userAgent;
      let Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPod"];
      let flag = true;
      for (let i = 0; i < Agents.length; i++) {
        if (userAgentInfo.indexOf(Agents[i]) > 0) {
          flag = false;
          break;
        }
      }
      if (window.screen.width >= 768) {
        flag = true;
      }
      return flag;
    },
    dataURLtoBlob(dataurl) {
      var arr = dataurl.split(",");
      //注意base64的最后面中括号和引号是不转译的
      var _arr = arr[1].substring(0, arr[1].length - 2);
      var mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(_arr),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], {
        type: mime,
      });
    },
    shareH5() {
      console.log("share");
    },
    test(e) {
      console.log(e);
    },
  },
};
</script>

<style lang="scss">
// vant组件样式
.van-tabs__wrap {
  height: 70px !important;
  .van-tabs__nav {
    display: inline-block;
    padding: 0;
    // width: 10%;
    .van-tab {
      padding: 0;
      margin-right: 15px;
      display: inline-block;
      color: #828393;
      .van-tab__text {
        font-size: 0.9em;
      }
    }
    .van-tab--active {
      &::after{
        content: "";
        width: 0;
        position: absolute;
        top: 1.9em;
        left: 50%;
        height: 0;
        transform: rotate(90deg)translateY(16%);
        border-bottom: 1em solid #2A2A30;
        border-left: 0.3em solid #2A2A30;
      }
      padding-bottom: 0.2em;
      color: #2A2A30;
      font-weight: 500;
    }
  }
  .van-tabs__line {
    display: none;
  }
}
body {
  background:linear-gradient(90deg,#557aff 0%,#4642ff 6.41%,#ff5572 102.62%);
}
.pc-mark {
  position: absolute;
  z-index: 100;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  .van-loading {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
// 遮罩层
.water-mark {
  position: fixed;
  width: 100%;
  max-width: 750px;
  height: 100vh;
  z-index: 5;
}
// 组件样式
.bodydiv {
  display: flex;
  align-items: center;
  flex-direction: column;
  padding-top: 20px;
  font-size: 20px;
  p,
  span {
    font-size: 20px;
    display: inline-block;
  }
  .top-desc {
    background-color: white;
    border-radius: 20px;
    width: 90%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    .desc_title {
      margin-top: 10px;
      box-sizing: border-box;
      width: 25%;
      span {
        // font-weight: 600;
        transform: translateX(-14%);
        border-radius: 45px;
        width: 100%;
        color: white;
        padding: 10px 20px;
        text-align: center;
        font-size: 1em;
      }
    }
    .desc_result {
      // margin-top: 0.5em;
      position: relative;
      letter-spacing: 0.2em;
      img {
        width: 22%;
        position: absolute;
        z-index: 4;
      }
      p {
        font-size: 1.5em;
        color: black;
        letter-spacing: 2%;
        z-index: 4;
        position: relative;
      }
    }
    .desc_container {
      width: 90%;
      margin-top: 40px;
      span {
        font-weight: 700;
        width: 140px;
        margin-right: 10px;
        font-size: 0.9em;
      }
      .desc_info {
        display: flex;
        justify-content: space-between;
        margin-bottom: 14px;
        img {
          border-radius: 15px;
          width: 170px;
          height: 170px;
        }
        .info_item {
          width: 60%;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          p {
            width: 80%;
            border-bottom: 1px solid;
            font-size: 0.9em;
          }
          div {
            display: flex;
          }
        }
        .info_img {
          position: relative;
          .img_mark {
            width: 170px;
            height: 170px;
            position: absolute;
            z-index: 6;
            top: 0;
          }
        }
      }
      .desc {
        display: flex;
        .label_container {
          width: 100%;
          text-align: justify;
          p {
            font-size: 0.9em;
          }
        }
      }
    }
    .more {
      margin: 10px 0;
      position: relative;
      z-index: 6;
      p {
        font-size: 0.9em;
        width: 100%;
        text-align: center;
        font-weight: 700;
        margin-right: 10px;
      }
    }
  }
  .bottom-detail {
    margin-top: 20px;
    background-color: white;
    border-radius: 20px;
    width: 90%;
    margin-bottom: 20px;
    .no_title {
      text-align: center;
      font-weight: 500;
    }
    .reason {
      display: flex;
      flex-direction: column;
      width: 90%;
      margin: 0 auto;
      color: #828393;
      font-weight: 400;
    }
    .detail_title,
    .detail_container {
      margin: 3% 4%;
      .tag {

      }
    }
    .detail_container {
      // .detail_point {
      //   font-size: 0.8em;
      // }
      .point_content {
        width: 100%;
        border-top: 1px solid RGB(240, 240, 245);
        .precent {
          position: relative;
          margin-top: 14%;
          .linear {
            width: 100%;
            height: 10px;
            background-color: #b3d9fc;
            background: linear-gradient(
              90deg,
              #557aff 0%,
              #4642ff 6.41%,
              #ff5572 102.62%
            );
          }
          .position_text {
            width: 150px;
            position: absolute;
            top: -2.1em;
            transform: scale(0.8) translateX(-14%);
            font-weight: 700;
            font-size: 1em;
          }
          .position {
            width: 0.2em;
            height: 18px;
            background-color: black;
            position: absolute;
          }
          .precent_tip {
            display: flex;
            justify-content: space-between;
            span {
              font-size: 0.9em;
              color: RGB(168, 168, 180);
            }
          }
        }
        .ponit_pic {
          position: relative;
          display: flex;
          align-items: center;
          flex-direction: row;
          margin: 20px 0;
          .picT,
          .picF {
            display: flex;
            justify-content: center;
            flex-direction: column;
            align-items: center;
            img {
              width: 265px;
              height: 265px;
            }
          }
          .picF {
            position: relative;
            .fake_mark {
              position: absolute;
              border: 1px solid red;
              z-index: 7;
              border-radius: 45px;
              width: 9%;
              height: 8%;
            }
          }
          .pic_markT {
            position: absolute;
            top: 0;
            z-index: 6;
            width: 60%;
            height: 90%;
          }
          .pic_markF {
            position: absolute;
            top: 0;
            z-index: 6;
            height: 3.5rem;
            width: 3.5rem;
          }
          img {
            width: 35%;
            height: 35%;
            background-color: black;
            object-fit: contain;
            margin-bottom: 10px;
          }
          .trueArea {
            position: absolute;
            background-color: rgba(0, 0, 0, 0);
          }
          .trueP {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .truePic {
              width: 60%;
              height: 60%;
              background-color: black;
              object-fit: contain;
              margin-bottom: 10px;
            }
          }
          p {
            color: RGB(181, 181, 181);
          }
        }
        .point_dsc {
          margin: 0 auto;
          width: 100%;
          border-radius: 15px;
          background-color: RGB(248, 248, 251);
          border: 1px solid RGB(238, 238, 238);
          p {
            padding: 2%;
          }
        }
      }
    }
  }
  .ccic-top {
    width: 100%;
    // height: 20vh;
    position: relative;
    z-index: 4;
    img {
      width: 100%;
    }
  }
}
// 中检底部
.ccic-bottom {
  width: 100%;
  // height: 26vh;
  position: relative;
  z-index: 6;
  img {
    width: 100%;
  }
  // background-size: 100% 31vh;
  // background-image: url(https://oss.turingsenseai.com/1624005265917545236.png);
}
// 分享
.shaer_mark {
  width: 100%;
  position: relative;
}
.share {
  height: 89px;
  width: 100vw;
  background-color: white;
  position: fixed;
  bottom: 0;
  z-index: 6;
  max-width: 750px;
  display: flex;
  span {
    transform: translateX(5.6%);
    width: 90%;
    background-color: #2A2A30;
    color: #fff;
    display: inline-block;
    
    text-align: center;
    
  }
}
// 海报

.poster {
  .poster_title {
    width: 100%;
    height: 6vh;
    line-height: 6vh;
    background-color: #f7f7f7;
    color: #363636;
    span {
      font-size: 1.1em;
      margin-left: 2%;
    }
  }
  .poster_container {
    // width: 100%;
    // display: flex;
    // justify-content: center;
    // align-items: center;
    overflow: scroll;
    width: 73%;
    margin: 0 auto;
    margin-top: 2vh;
    display: flex;
    align-items: center;
    .back_img {
      // transform: translate(2vh, 3vh);
      width: 100%;
      background-repeat: no-repeat;
      .back_IMG {
        width: 73%;
        // height: 70vh;
        position: absolute;
        z-index: -1;
      }
      .isAI_mark {
        height: 14vh;
      }
      .back_title {
        font-size: 1.5em;
        font-weight: 600;
        color: #0A4074;
        display: inline-block;
        width: 100%;
        line-height: 14vh;
        text-align: center;
        // margin-bottom: 10px;
      }
      .poster_info {
        display: flex;
        justify-content: space-around;
        // align-items: center;
        // margin-bottom: 2vh;
        .poster_item {
          display: flex;
          flex-direction: column;
          div {
            display: flex;
            // align-items: center;
            margin-bottom: 20px;
            span {
              font-size: 0.9em;
              // margin-right: 10px;
            }
            p {
              font-size: 0.9em;
              color: #9a9ba8;
            }
          }
        }
      }
      .poster_img {
        // width: 25%;
        // height: 25%;
      }
      .poster_desc {
        width: 85%;
        // margin-left: 17px;
        span {
          display: inline-block;
          font-size: 1em;
          margin-bottom: 5px;
        }
        // p {
        //   // font-size: 0.9em;
        //   // height: 10vh;
        //   // line-height: 2.6vh;
        //   overflow: hidden;
        //   // text-overflow: ellipsis;
        //   // display: -webkit-box;
        //   // -webkit-line-clamp: 3;
        //   // -webkit-box-orient: vertical;
        //   color: #9a9ba8;
        // }
      }
      .bottom-icon {
        width: 100%;
      }
      .qrcode {
        display: flex;
        justify-content: flex-end;
        margin: 0 0 0 70%;
        width: 4em;
        height: 4em;
        background-size: 4em 4em;
        background-repeat: no-repeat;
        img {
          width: 4em;
          height: 4em;
        }
      }
    }
  }
  .downImg {
    // position: absolute;
    // margin-top: 50%;
    width: 73%;
    // top: 6vh;
    height: 60vh;
    // transform: translateY(-25%);
  }
  .save {
    background-color: #2a2a30;
    height: 6vh;
    border: none;
  }
  .van-icon {
    top: 3.5%;
    transform: translateY(-50%);
  }
}
.boswer_poster {
  .poster_title {
    width: 100%;
    height: 50px;
    line-height: 50px;
    font-size: 18px;
    background-color: #f7f7f7;
    color: #363636;
    span {
      margin-left: 2%;
    }
  }
  .downImg {
    transform: translate(5vh, 5vh);
    height: 600px;
  }
  .poster_container {
    width: 100%;
    height: 500px;
    // display: flex;
    // justify-content: center;
    // align-items: center;
    .back_img {
      transform: translate(7vh, 5vh);
      height: 500px;
      width: 75%;
      background-size: 100% 500px;
      background-repeat: no-repeat;
      .isAI_mark {
        height: 18%;
      }
      .back_title {
        color: #2d5c88;
        display: inline-block;
        width: 100%;
        line-height: 14vh;
        text-align: center;
        font-size: 18px;
      }
      .poster_info {
        display: flex;
        justify-content: space-around;
        align-items: center;
        // margin-bottom: 1vh;
        .poster_item {
          display: flex;
          flex-direction: column;
          div {
            display: flex;
            align-items: center;
            // margin-bottom: 5px;
            span,
            p {
              font-size: 0.2em;
            }
            span {
              margin-right: 10px;
            }
            p {
              color: #9a9ba8;
            }
          }
        }
      }
      .poster_img {
        background-size: 25% 25%;
      }
      .poster_desc {
        width: 85%;
        margin: 0 auto;
        span {
          display: inline-block;
          font-size: 0.2rem;
          margin-bottom: 0.1rem;
        }
        p {
          font-size: 0.2em;
          line-height: 3.2em;
          overflow: hidden;
          // text-overflow: ellipsis;
          // display: -webkit-box;
          // -webkit-line-clamp: 4;
          // -webkit-box-orient: vertical;
          color: #9a9ba8;
        }
      }
      .qrcode {
        display: flex;
        justify-content: flex-end;
        margin: 0 0 0 70%;
        width: 2em;
        height: 2em;
        background-size: 2em 2em;
        background-repeat: no-repeat;
        img {
          width: 2em;
          height: 2em;
        }
      }
    }
  }
  .save {
    background-color: #2a2a30;
    height: 50px;
    border: none;
    border-radius: 0;
  }
  .van-icon {
    font-size: 28px;
    top: 4%;
    transform: translateY(-50%);
  }
}
</style>
